{
  "failLoadDxmlFile": "(500) Kunne ikke laste inn DXML fil",
  "failSaveDocument": "(501) Kunne ikke lagre dokumentet",
  "failLoadFile": "(502) Kunne ikke laste inn filen",
  "failLoadData": "(503) Kunne ikke laste inn data",
  "failSearch": "(504) Kunne ikke søke",
  "failSearchAttachment": "(505) Kunne ikke søke i vedlegg",
  "failLoadFileExtension": "(506) Kunne ikke laste filen fordi filtypen ",
  "failLoadFileExtensionIsNotSupport": " ikke støttes.",
  "disableDistributionError": "(507) Kan ikke publisere dokumentet. Vennligst deaktiver distribusjon i WebEditor-innstillingene i CenterPoint.",
  "enableDistributionError": "(508) Kan ikke publisere dokumentet. Aktiver distribusjon i WebEditor-innstillingene i CenterPoint.",
  "selectFileTooLarge": "(509) Den valgte filen er for stor. Maksimal filstørrelse er 1 MB.",
  "inactiveDistributionList": "(510) Distribusjonslisten i Pages manager er ikke aktivert.",
  "noActiveDistributionAlternatives": "(511) Distribusjonslisten i Page manager har ingen aktive distribusjonsalternativer.",
  "publishErrorMsg": "(513) Dokumentet kan ikke publiseres på grunn av ugyldig eller ufullstendig informasjon i ett eller flere felt."
}